/**
 * codmon-toggletip の「閉じる」操作を配線するフレームワーク非依存のコア。
 * ディレクティブ本体は angular 依存で jest からロードできないため、ここだけ切り出してテストする。
 * 開く操作はトリガーの ng-click が担うので扱わない。解除用の teardown を返す。
 */
export type ToggletipDismissOptions = {
  isOpen: () => boolean;
  onDismiss: () => void;
};

export function bindToggletipDismiss(root: HTMLElement | null, options: ToggletipDismissOptions): () => void {
  if (!root) {
    return () => {};
  }

  // トリガーは root の中なので素通りする。トグルは ng-click 側だけが効く
  const onDocumentClick = (event: Event): void => {
    const target = event.target as Node | null;
    if (!options.isOpen()) return;
    if (target && root.contains(target)) return;
    options.onDismiss();
  };

  const onKeydown = (event: Event): void => {
    if ((event as KeyboardEvent).key !== 'Escape') return;
    if (!options.isOpen()) return;
    options.onDismiss();
  };

  const bindings: Array<[EventTarget, string, (event: Event) => void]> = [
    [document, 'click', onDocumentClick],
    [document, 'keydown', onKeydown],
  ];

  bindings.forEach(([el, type, fn]) => el.addEventListener(type, fn));
  return () => bindings.forEach(([el, type, fn]) => el.removeEventListener(type, fn));
}
